const src = require("/app/src/assets/images/svg/home-icon.svg?as-resource");
const img = new String(src);
img.src = src;
img.width = 17;
img.height = 18;
img.toString = function() { return src; };
module.exports = img;